export function intersection<T>(a: Set<T>, b: Set<T>): Set<T> {
	return new Set([...a].filter(value => b.has(value)));
}
